import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { Button } from 'ui-components/components/button';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import Global from '../../../../../store/global-selectors';
import { messages } from '../../../messages';
import { ActivityItem } from './activity-item';
import moment from 'moment';
import classnames from 'clsx';
import generalStyle from '../../../style.module.less';
import style from './style.module.css';

export const ProductActivity = ({ activity, totalCount, loadNextPage, isLoading = false }) => {
  const userDateFormat = useSelector(Global.selectUserUserDateFormat);
  const userTimeFormat = useSelector(Global.selectUserUserTimeFormat);
  const dateTimeFormat = `${userDateFormat} ${userTimeFormat}`;

  const renderLoadMoreButton = useCallback(() => {
    return isLoading ? (
      <LoadingIndicator />
    ) : (
      <Button onClick={loadNextPage} theme='link'>
        Load More
      </Button>
    );
  }, [isLoading, loadNextPage]);

  const activityKeys = Object.keys(activity).sort((a, b) => b - a);

  return (
    <>
      <div className={classnames(generalStyle['shipping-defaults-header-wrapper'], generalStyle.dropped)}>
        <div className={generalStyle['shipping-defaults-header-text']}>
          <FormattedMessage {...messages.productActivity} />
        </div>
      </div>
      <div className={style['product-activity']}>
        {activityKeys.map((activityItemId) => (
          <ActivityItem
            key={activity[activityItemId].logId}
            message={activity[activityItemId].message}
            time={moment(activity[activityItemId].createDateTime).format(dateTimeFormat)}
            userName={activity[activityItemId].userName}
          />
        ))}
        {activity.length < totalCount && <div className={style['load-more']}>{renderLoadMoreButton()}</div>}
      </div>
    </>
  );
};

ProductActivity.propTypes = {
  activity: PropTypes.object.isRequired,
  totalCount: PropTypes.number.isRequired,
  loadNextPage: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};
